export default __webpack_public_path__ + "static/cyclist-illus-f42fbacdcc3cbd70b8b9bbee95acef55.svg";